import ModalOptions, { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import eventBus from './eventBus';
import { app } from '@/main';
import flagKeys from '@/constants/flagKeys';
import { IBusinessType } from '@/models/business';
import { EBillingStatusTypes } from '@/store/modules/businessTypes';
import { getMerchantMeetingOboardingState } from '@/router/router-utils';
import { EOnboardingMeetingStatus } from '@/models/onboarding-call';
import { getBillingIsPending } from './billing';

const openCenterModalConfig = (
  modalName: string,
  mobilePositionBottom?: boolean
) =>
  new ModalOptions(
    ``,
    ``,
    'none',
    true,
    ``,
    ``,
    ``,
    false,
    modalName,
    false,
    true,
    true,
    false,
    false,
    null,
    true,
    mobilePositionBottom
  );

export const openCenterModal = (modalName: string, ...args: any) => {
  eventBus.$emit(
    'openSubModal',
    openCenterModalConfig(modalName, args && args.mobilePositionBottom),
    ...args
  );
};

export const openDefaultModal = (modalName: string, ...args: any) => {
  eventBus.$emit(
    'openSubModal',
    new ModalOptionsV2({
      componentToRender: modalName,
      hideCancelButton: false,
      icon: '',
      mobileFullScreen: false,
      mobilePositionBottom: true
    }),
    args
  );
};

export const showModalBillingLocationBenefits = () => {
  const business = app.$store.getters['business/getBusinessInfo'].business;

  if (!business || business.type === IBusinessType.INSTORE) return false;

  return (
    app.$store.getters['flags/getFlags'].includes(flagKeys.billingModuleV4) &&
    business.country === 'United States' &&
    (getBillingIsPending() ||
      business.subscriptionStatus === EBillingStatusTypes.UNAVAILABLE)
  );
};

export const showModalOnboardingCall = () => {
  const business = app.$store.getters['business/getBusinessInfo'].business;

  if (!business || business.type !== IBusinessType.INSTORE) return false;

  return (
    app.$store.getters['flags/getFlags'].includes(
      flagKeys.showOnboardingCallBanner
    ) &&
    business.country === 'United States' &&
    !!business.onboardingMeeting &&
    business.onboardingMeeting.status === EOnboardingMeetingStatus.PENDING &&
    !getMerchantMeetingOboardingState()
  );
};
